import $ from 'jquery'

const object = vnObject

$('.js-home-header-btn').hover(
    function() {
        // Récupérer l'URL de l'image depuis l'attribut data-img-url
        let imageUrl = $(this).data('img-url');
        // Appliquer l'image en background de .js-home-header
        $('.js-home-header').css('background-image', 'url(' + imageUrl + ')');
        $('.js-home-video').css('display', 'none');
    },
    function() {
        // Retirer l'image de fond au mouseleave
        $('.js-home-header').css('background-image', '');
        $('.js-home-video').css('display', 'block');
    }
);

if ($('.js-home-header').length) {
    $(window).on('scroll', function () {
        if ($(window).scrollTop() === 0) {
            $('.js-home-navbar').addClass('on-top');
            $('.js-header-logo').attr('src', object.whiteLogo);
        } else {
            $('.js-home-navbar').removeClass('on-top');
            $('.js-header-logo').attr('src', object.darkLogo);
        }
    }).trigger('scroll');
}